export * from './helpers'
export { type SemanticType, type SemanticValue } from './types'

export const semanticTypes = {
  sequence: {
    quote: {
      quote: 'sequence.quote',
      totalContractValue: 'sequence.quote.totalContractValue',
      totalDiscountValue: 'sequence.quote.totalDiscountValue',
      productIds: 'sequence.quote.productIds',
      productDiscounts: 'sequence.quote.productDiscounts',
      phases: 'sequence.quote.phases',
      rawText: 'sequence.quote.rawText',
      currency: 'sequence.quote.currency',
      totalDuration: 'sequence.quote.totalDuration',
      startDate: 'sequence.quote.startDate',
      dealType: 'sequence.quote.dealType',
      paymentTerms: 'sequence.quote.paymentTerms',
      attachments: 'sequence.quote.attachments'
    },
    // Mirrors the quote namespace for the properties a template holds. Values
    // are published by a condition's `valueSupportingTask`, not by an upstream
    // node's `outputMapping`, and are scoped per template at runtime.
    quoteTemplate: {
      quoteTemplate: 'sequence.quoteTemplate',
      attachments: 'sequence.quoteTemplate.attachments',
      rawText: 'sequence.quoteTemplate.rawText',
      // Days until an invoice from a quote on this template falls due. Unset
      // means the quote takes the account default.
      paymentTerms: 'sequence.quoteTemplate.paymentTerms'
    },
    // The version of the quote under review that was last approved, published
    // by a condition's `valueSupportingTask` from the `previous_quote_approval`
    // executor. `outcome` marks an approval as present and approved, so every
    // comparison against it can gate on one key.
    previousQuoteApproval: {
      outcome: 'sequence.previousQuoteApproval.outcome',
      rawText: 'sequence.previousQuoteApproval.rawText',
      attachments: 'sequence.previousQuoteApproval.attachments',
      // Days until an invoice from the approved quote falls due. Unset means it
      // took the account default.
      paymentTerms: 'sequence.previousQuoteApproval.paymentTerms'
    },
    // The outcomes of the `compare_quote_pricing` executor, comparing a quote's
    // pricing against a template's or its last approved version's — so each is
    // published scoped to the subject compared. Keys are the executor's own
    // output fields, which the supporting task derives each path from. It also
    // reports `phasesMatch`, which no comparison surfaces separately, so it
    // isn't published.
    quotePricingComparison: {
      allMatch: 'sequence.quotePricingComparison.allMatch',
      pricesMatch: 'sequence.quotePricingComparison.pricesMatch',
      discountsMatch: 'sequence.quotePricingComparison.discountsMatch',
      minimumsMatch: 'sequence.quotePricingComparison.minimumsMatch'
    },
    invoice: {
      id: 'sequence.invoice.id',
      grossTotal: 'sequence.invoice.grossTotal',
      currency: 'sequence.invoice.currency',
      dueDate: 'sequence.invoice.dueDate',
      customerId: 'sequence.invoice.customerId'
    },
    customer: {
      customer: 'sequence.customer',
      id: 'sequence.customer.id',
      customProperties: 'sequence.customer.customProperties'
    },
    user: 'sequence.user',
    billingSchedule: 'sequence.billingSchedule',
    contract: {
      fullContract: 'sequence.contract',
      name: 'sequence.contract.name'
    },
    asset: {
      fullAsset: 'sequence.asset',
      id: 'sequence.asset.id',
      fileName: 'sequence.asset.fileName'
    },
    requestorId: 'sequence.requestorId',
    quoteApproval: {
      requestorComment: 'sequence.quoteApproval.requestorComment',
      signatureConfiguration: 'sequence.quoteApproval.signatureConfiguration'
    }
  }
} as const
